import { render, staticRenderFns } from "./AppClientView.vue?vue&type=template&id=37aada52&scoped=true&"
import script from "./AppClientView.vue?vue&type=script&lang=js&"
export * from "./AppClientView.vue?vue&type=script&lang=js&"
import style0 from "./AppClientView.vue?vue&type=style&index=0&id=37aada52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aada52",
  null
  
)

export default component.exports